// extracted by mini-css-extract-plugin
export default {"mr10":"components-Export-index__mr10--AanHc"};